import { getLocale } from './getLocale.js';
import type { StartScreenPrompt, StartScreenOption } from '@openai/chatkit-react';

const getStartScreenPrompts = (): StartScreenPrompt[] => {
  if (getLocale() === 'sv') {
    return [
      {
        label: 'Sammanfatta integrationen',
        icon: 'notebook',
        prompt: 'Sammanfatta vad denna integration gör.',
      },
      {
        label: 'Konfigurera steg',
        icon: 'lab',
        prompt: 'Undersök integrationen och det nuvarande steget jag kollar på. Ställ mig frågor om mina behov för att därefter kunna uppdatera och konfigurera steget.'
      },
      {
        label: 'Vill veta mer om integrationsmöjligheterna',
        icon: 'analytics',
        prompt: 'Berätta mer om vilka integrationsmöjligheter som finns hos Standout.'
      }
    ]
  }

  return [
    {
      label: 'Summarize the integration',
      icon: 'notebook',
      prompt: 'Summarize what this integration does.'
    },
    {
      label: 'Configure the step',
      icon: 'lab',
      prompt: 'Inspect the integration and the current step I am looking at. Ask me questions about my needs so I can then update and configure the step.'
    },
    {
      label: 'I want to know more about integration possibilities',
      icon: 'analytics',
      prompt: 'Tell me more about which integration possibilities are available at Standout.'
    }
  ]
};

const getStartScreenGreeting = (): string => {
  if (getLocale() === 'sv') {
    return 'Hej! Vad kan jag hjälpa dig med idag?'
  }
  return 'Hello! What can I help you with today?'
}

const startScreen: StartScreenOption = {
  prompts: getStartScreenPrompts(),
  greeting: getStartScreenGreeting(),
}

export default startScreen;
